import axios from '../axios';

const accountingReportsApi = {
  getStatement: (params) => axios.get('/AccountingReports/statement', { params }),
  getTrialBalance: (params) => axios.get('/AccountingReports/trial-balance', { params }),
  getIncomeStatement: (params) => axios.get('/AccountingReports/income-statement', { params }),
  getBalanceSheet: (params) => axios.get('/AccountingReports/balance-sheet', { params }),
};

export default accountingReportsApi;
